<template>
  <div class="container mt-lg-5 mb-5">
    <div class="d-flex flex-row">
      <div class="d-flex flex-row align-items-center justify-content-center gap-2">
        <router-link to="/personas" class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('volver') }}</span>
        </router-link>
        <h2 class="m-0">{{ $t('rol') }}</h2>
      </div>
    </div>
    <div>
      <form @submit.prevent="saveChanges" class="d-flex flex-column gap-2">

        <div class="fs-7 w-100">
          <strong>{{ $t('nombreRol') }}:</strong> 
          <div class="d-flex gap-2 w-100 align-items-center justify-content-center">
            <input type="text" v-model="rol.Rol" class="form-control sombra-sm" required/>
            <!-- Oculto checkbox -->
            <div class="d-flex align-items-center gap-2">
              <input type="checkbox" v-model="rol.Oculto" id="oculto" class="form-check-input m-0 sombra-sm"/>
              <label for="oculto" class="form-label m-0 fs-7"><strong>{{ $t('rolOculto') }}</strong></label>
            </div>
          </div>
        </div>

        <div class="fs-7 w-100">
          <strong>{{ $t('descripcion') }}:</strong> 
          <textarea id="descripcion" v-model="rol.Descripcion" class="form-control sombra" style="height: 120px; resize: none;" maxlength="1000"></textarea>
          <div class="mt-2 text-end">
            <span>{{ rol.Descripcion?.length ?? 0 }}/1000 {{ $t('caracteres') }}</span> <!-- Actualiza el número según tu límite -->
          </div>
        </div>


        <!-- Permisos -->
        <div class="d-flex flex-column w-100">
          <!-- Mostrar permisos actuales -->
          <p class="fs-7 m-0"><strong>{{ $t('permisos') }}:</strong></p>
          
          <div v-if="allPermisos" class="scroll" style="max-width: 800px;">
            <div class="d-flex flex-column gap-3">
              <div v-for="group in groupedPermisos" :key="group.name">
                <!-- <h5 class="mt-3">{{ group.name }}</h5> <hr class="my-2"> -->
                <div class="m-0 fs-8 mb-1 d-flex gap-3 align-items-start">
                  <p class="fs-6 m-0 text-end" style="flex: 1;">
                    <span class="fw-bold">{{ group.name }}</span>
                  </p>
                  <div style="flex: 2;">
                    <div v-for="subgroup in group.subcategories" :key="subgroup.IdPermiso">
                      <div v-if="subgroup.permiso != 'General'" class="form-check d-flex gap-3 p-0">
                        <input
                          class="form-check-input sombra-sm m-0"
                          :class="{'form-check-input-gris': isSubcategoryChecked(subgroup).checkedEnRol}"
                          type="checkbox"
                          :checked="isSubcategoryChecked(subgroup).checked"
                          @change="toggleSubcategory(subgroup, $event.target.checked)"
                        />
                        <div class="d-flex gap-1" @click="expandedSubcategories[subgroup.IdPermiso] = !expandedSubcategories[subgroup.IdPermiso]" style="cursor: pointer;">
                          <p class="m-0 text-start">{{ subgroup.permiso }}</p>
                          <p class="m-0 text-start">({{ subgroup.children.filter( c => hasPermiso(c.IdPermiso, c.SubCategoria).enPermiso || hasPermiso(c.IdPermiso, c.SubCategoria).enRol)?.length }})</p>
                          <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ transform: expandedSubcategories[subgroup.IdPermiso] ? 'scaleY(1)' : 'scaleY(-1)' }">
                            <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" class="fill-principal"/>
                          </svg>
                        </div>
                      </div>

                      <div v-if="subgroup.permiso != 'General' && expandedSubcategories[subgroup.IdPermiso]" class="ms-5">
                        <div class="m-0 fs-8 mb-1 d-flex gap-3" v-for="fullPermiso in subgroup.children" :key="fullPermiso.IdPermiso">
                          <div class="form-check d-flex gap-3 p-0">
                            <input
                                class="form-check-input sombra-sm m-0"
                                :class="{'form-check-input-gris': hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enRol}"
                                type="checkbox"
                                :checked="hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enPermiso || hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enRol"
                                @change="togglePermiso(fullPermiso, $event.target.checked)"
                            />
                            <p class="m-0 text-start">
                                {{ fullPermiso.permiso }}
                            </p>

                            <div v-if="fullPermiso.Descripcion" class="tooltip-container">
                              <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill="none" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                  <circle cx="12" cy="12" r="10"></circle>
                                  <line x1="12" y1="16" x2="12" y2="12"></line>
                                  <line x1="12" y1="8" x2="12" y2="8"></line>
                              </svg>
                              <span class="tooltip-text-left text-left" style="max-width: 50vw; width: 350px;">
                                  <p class="m-0 fs-8">{{fullPermiso.Descripcion}}</p>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="subgroup.permiso == 'General'">
                        <div class="m-0 fs-8 mb-1 d-flex gap-3" v-for="fullPermiso in subgroup.children" :key="fullPermiso.IdPermiso">
                          <div class="form-check d-flex gap-3 p-0">
                            <input
                                class="form-check-input sombra-sm m-0"
                                :class="{'form-check-input-gris': hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enRol}"
                                type="checkbox"
                                :checked="hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enPermiso || hasPermiso(fullPermiso.IdPermiso, fullPermiso.SubCategoria).enRol"
                                @change="togglePermiso(fullPermiso, $event.target.checked)"
                            />
                            <p class="m-0 text-start">
                                {{ fullPermiso.permiso }}
                            </p>

                            <div v-if="fullPermiso.Descripcion" class="tooltip-container">
                              <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill="none" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                  <circle cx="12" cy="12" r="10"></circle>
                                  <line x1="12" y1="16" x2="12" y2="12"></line>
                                  <line x1="12" y1="8" x2="12" y2="8"></line>
                              </svg>
                              <span class="tooltip-text-left text-left" style="max-width: 50vw; width: 350px;">
                                  <p class="m-0 fs-8">{{fullPermiso.Descripcion}}</p>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-row gap-2">
          <button class="btn btn-success mt-3 sombra-sm" type="submit">{{ $t('guardar') }}</button>
          <button class="btn btn-secondary mt-3 sombra-sm">{{ $t('cancelar') }}</button>
          <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
            <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted, computed, reactive } from 'vue';
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  name: 'EditarRoles',
  setup() {
    const { t } = useI18n();
    var loading = ref(false);
    //var loadingPermiso = ref(false);
    const router = useRouter();
    //const user = computed(() => store.state.user);
    const rol = ref({Rol:'',Permisos:[],IdRol:'00000000-0000-0000-0000-000000000000',Oculto:false});
    const allPermisos = ref([]);
    var selectedPermiso = ref({});
    const expandedSubcategories = reactive({});

    const hasPermiso = (permisoId) => {
      // Check if the current persona has this specific permission
      const hasPermiso = rol.value.Permisos?.some(
        pp => pp.IdPermiso === permisoId
      );
      return { enPermiso: hasPermiso };
    };

    const togglePermiso = (permiso, isChecked) => {
      // This method would handle updating the persona's permissions.
      console.log(
        `Permiso ID: ${permiso.IdPermiso}, Checked: ${isChecked}`
      );
      if (isChecked) {
        if (!rol.value.Permisos) {
          rol.value.Permisos = [];
        }
        rol.value.Permisos.push({
          IdPersona: rol.value.IdPersona,
          IdPermiso: permiso.IdPermiso,
          IdPermisoNavigation: permiso
        });
      } else {
        rol.value.Permisos = rol.value.Permisos.filter(
          pp => pp.IdPermiso !== permiso.IdPermiso
        );
      }
      //console.log(rol.value.Permisos)
    };

    const isSubcategoryChecked = (subgroup) => {
      // Una subcategoría está marcada si *todos* sus permisos hijos están marcados
      // (ya sea directamente o por rol)
      const checked = subgroup.children.every(p => {
        const status = hasPermiso(p.IdPermiso, p.SubCategoria);
        return status.enPermiso || status.enRol;
      });
      const checkedEnRol = subgroup.children.every(p => {
        const status = hasPermiso(p.IdPermiso, p.SubCategoria);
        return status.enRol;
      });
      return { checked: checked, checkedEnRol: checkedEnRol };
    };

    // Nueva: Maneja el cambio del checkbox de la subcategoría
    const toggleSubcategory = (subgroup, isChecked) => {

      console.log(`Toggle Subcategoría: ${subgroup.permiso}, Checked=${isChecked}`);

      // Iterar sobre todos los permisos hijos de esta subcategoría
      subgroup.children.forEach(permisoIndividual => {
        // La propiedad 'Subcategoria' de cada permisoIndividual aquí ya contiene el VALOR específico
        // (ej. 'Inicial', 'Boletines')
        togglePermiso(permisoIndividual, isChecked);
      });
    };

    const groupedPermisos = computed(() => {
      const categories = {}; // Objeto para agrupar por Categoria

      allPermisos.value.forEach(permiso => {
        const categoria = permiso.Categoria || 'Otros';
        const SubCategoria = permiso.SubCategoria || 'General'; // Usa 'General' si SubCategoria es null o vacía

        if (!categories[categoria]) {
          categories[categoria] = {}; // Crea un objeto para las subcategorías dentro de esta categoría
        }
        if (!categories[categoria][SubCategoria]) {
          categories[categoria][SubCategoria] = []; // Crea un array para los permisos dentro de esta subcategoría
        }
        categories[categoria][SubCategoria].push(permiso);
      });

      const result = [];
      const sortedCategoryNames = Object.keys(categories).sort((a, b) => {
        if (a === 'Otros') return 1;
        if (b === 'Otros') return -1;
        return a.localeCompare(b);
      });

      sortedCategoryNames.forEach(categoryName => {
        const subcategoriesData = [];
        const sortedSubcategoryNames = Object.keys(categories[categoryName]).sort((a, b) => {
          if (a === 'General') return -1; // 'General' (sin subcategoría) primero
          if (b === 'General') return 1;
          return a.localeCompare(b);
        });

        sortedSubcategoryNames.forEach(subcategoryName => {
          // Obtenemos los permisos de esta subcategoría
          const permisosInSubcategory = categories[categoryName][subcategoryName].sort((a, b) =>
            a.permiso.localeCompare(b.permiso)
          );

          // También necesitamos un "permiso proxy" para la subcategoría si queremos marcarlo
          // Esto es crucial para poder tener un checkbox a nivel de subcategoría
          // que represente el estado de todos sus permisos hijos.
          // Para simplificar ahora, el ID de este "permiso proxy" puede ser un ID sintético.
          const subcategoryProxyPermiso = {
            IdPermiso: `_SUB_${categoryName}_${subcategoryName}`, // ID sintético para el checkbox de subcategoría
            permiso: subcategoryName, // El nombre que se mostrará para la subcategoría
            Descripcion: `Gestiona todos los permisos de ${subcategoryName} dentro de ${categoryName}.`,
            Categoria: categoryName,
            SubCategoria: subcategoryName,
            isSubcategoryHeader: true, // Indicador para el template
            children: permisosInSubcategory, // Los permisos reales anidados
          };

          subcategoriesData.push(subcategoryProxyPermiso);
        });

        result.push({
          name: categoryName,
          subcategories: subcategoriesData // Ahora contiene las subcategorías con sus permisos hijos
        });
      });

      return result;
    });
    // Fetch permisos de la BD
    const fetchPermisos = async () => {
      try {
        const response = await api.get(`api/Permisos`);
        allPermisos.value = response.data;
      } catch (error) {
        console.error('Error al obtener permisos:', error);
      }
    };

    const addPermission = () => {
      if (selectedPermiso.value && !rol.value.Permisos.some(p => p.IdPermiso === selectedPermiso.value.IdPermiso)) {
        rol.value.Permisos.push(selectedPermiso.value);
        selectedPermiso.value = {}; // Limpiar selección después de agregar
        console.log(rol.value)
        console.log(selectedPermiso.value)
      }
    }

    const saveChanges = async () => {
      try {
        // Si Permisos no existe o está vacío, agregar un objeto vacío
        if (!rol.value.Permisos || rol.value.Permisos.length === 0) {
            rol.value.Permisos = [{}]; // Agregar un objeto vacío
        }
        convertEmptyToNull(rol.value)
        console.log(rol.value)
        const listaIdsValidos = rol.value.Permisos
          ?.filter(p => p.IdPermiso) // Elimina {} o cualquier objeto sin IdPermiso
          .map(p => p.IdPermiso);    // Extrae solo el ID

        var data = {
          Rol: rol.value.Rol,
          Oculto: rol.value.Oculto,
          Descripcion: rol.value.Descripcion,
          // 2. Si la lista tiene elementos, la mandamos; si no, mandamos null
          IdsPermisos: (listaIdsValidos && listaIdsValidos.length > 0) ? listaIdsValidos : null,
        };
        console.log(data)
        await api.post(`api/Roles`, data);
        loading.value = false;
        await router.push('/personas');
      } catch (error) {
        console.error('Error al guardar los cambios:', error);
        alert('Hubo un problema al guardar los datos.');
      }
    };

    const convertEmptyToNull = (obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === "") {
          obj[key] = null;
        }
      });
    }

    const removeRol = (index) => {
      // Eliminar la nacionalidad en el índice dado
      rol.value.Permisos.splice(index, 1);
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      fetchPermisos();
    });

    return {
      t,
      rol,
      loading,
      saveChanges,
      allPermisos,
      selectedPermiso,
      expandedSubcategories,
      groupedPermisos,
      toggleSubcategory,
      togglePermiso,
      isSubcategoryChecked,
      hasPermiso,
      addPermission,
      removeRol,
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}
</style>
